import {Inject, Injectable, Input} from 'ng-metadata/core';
import {getBackendSystem, getCurrentPCKey, getVid, getInstitutionCode, isCDI} from "../../appConfig/appConfigForward";
import {PrimoResponse} from "../../infra/dataStructures/PrimoResponses/doc.interfcae";
import {JwtUtilService} from "../../security/jwtUtil.service";
import {UserSessionManagerService} from "../../security/userSessionManager.service";
import {SearchService} from "../search.service";
import {preventStateReload} from "../../infra/annotations";
import {SearchStateService} from '../searchState.service';

const clone = require('lodash/clone');
const get = require('lodash/get');

@Injectable()
export class ChaptersAndReviewsService {

    private relatedItems;
    private _item: PrimoResponse.IExtendedDoc;
    private relatedItemsObj;
    /*@Input() item: PrimoResponse.IExtendedDoc;*/
    private vid: string = getVid();

    constructor(@Inject('$http') private $http: ng.IHttpService,
                @Inject('restBaseURLs') private restBaseURLs,
                private jwtUtilService: JwtUtilService,
                private userSessionManagerService: UserSessionManagerService,
                private searchStateService: SearchStateService,
                private searchService: SearchService,
                @Inject('$location') private $location: ng.ILocationService) {

        this.relatedItems = this.restBaseURLs.relateditems;
    }

    set item(item) {
        this._item = item;
    }

    // The specific item we came from
    get item() {
        return this._item;
    }

    public getRelatedItems(item) {

        let frbrgroupid = get(item, 'pnx.facets.frbrgroupid[0]');

        // URM-198605 : Alma records are not relied on groupid as CDI records do, 
        // therefore if there's no value in groupid, we fix it by set custom value, for example the mmsid
        if(!frbrgroupid){
            let mmsid: string = get(item, 'pnx.control.sourcerecordid[0]', '');
            item.pnx.facets.frbrgroupid = [mmsid];
        }

        if (this.relatedItemsObj && this.relatedItemsObj.results && this.relatedItemsObj.results[frbrgroupid]) {
            return;
        }
        let itemType=get(item,'pnx.display.type[0]');
        if(itemType!='book' && itemType!='books' && itemType!='book chapter' && itemType!='book review' && itemType!='book_chapter'){
        	console.log('Related item call only for book or book chapter or book review not for : '+itemType);
        	return;
        }
        let myitem = {
            'display': item.pnx.display,
            'search': item.pnx.search,
            'control': item.pnx.control,
            'facet': item.pnx.facets,
            'addata': item.pnx.addata
        }
        let searchObjectfacets = get(this.searchStateService.getSearchObject(), 'facets', null);
        if(searchObjectfacets && Array.isArray(searchObjectfacets)){
            let frbrFacet = searchObjectfacets.find(facet => {  return facet.name === 'frbrgroupid'});
            if(frbrFacet && myitem.facet && !myitem.facet.frbrgroupid){
                myitem.facet.frbrgroupid = [frbrFacet.value];
            }            
        }
        let pcKey = getCurrentPCKey();
        let institutionCode = getInstitutionCode();
        let signedIn = this.isSignedIn();
        let lang = this.userSessionManagerService.getUserLanguage();
        let facetType = 'frbrgroupid' ;
        let isCDIVal = isCDI();

        let payload = {
            'vid': this.vid,
            'institutionCode': institutionCode,
            'signedIn': signedIn,
            'pcKey': pcKey,
            'lang': lang,
            'isCDI': isCDIVal,
            'items': [myitem],
        };
        this.$http.post(this.relatedItems, payload).then((response: any) => {
            this.relatedItemsObj = response.data;
        });

        // return   6725473
    }

    public groupIDsChapters(frbrGroupId) {
        if (!this.relatedItemsObj) {
            return;
        }
        if (!this.relatedItemsObj.results[frbrGroupId]) {
            return;
        }
        return this.relatedItemsObj.results[frbrGroupId].relatedItems['Book Chapter'].groupIds;
    }

    public multiFacetsBookChapter(frbrGroupId) {
        let groupIDsChapters =  this.groupIDsChapters(frbrGroupId);
        if (!groupIDsChapters) {
            return;
        }
        return groupIDsChapters.map(e => 'frbrgroupid,include,' + e+',1');
    }

    public groupIDsReviews(frbrGroupId) {
        if (!this.relatedItemsObj) {
            return;
        }
        if (!this.relatedItemsObj.results[frbrGroupId]) {
            return;
        }
        return this.relatedItemsObj.results[frbrGroupId].relatedItems['Book Review'].groupIds;
    }

    public multiFacetsBookReviews(frbrGroupId) {
        let groupIDsReviews =  this.groupIDsReviews(frbrGroupId);
        if (!groupIDsReviews) {
            return;
        }
        return groupIDsReviews.map(e => 'frbrgroupid,include,' + e+',1');
    }

    public getBookChapters(frbrGroupId) {
        return get(this.relatedItemsObj, 'results['+frbrGroupId+'].relatedItems["Book Chapter"]');
    }

    public getBookReviews(frbrGroupId) {
        return get(this.relatedItemsObj, 'results['+frbrGroupId+'].relatedItems["Book Review"]');
    }

    public isSignedIn() {
        return this.jwtUtilService.isSignedIn();
    }

    public chaptersFrbrGroupId(doc: PrimoResponse.IDoc): string {
        return get(doc.pnx, 'facets.frbrgroupid[0]');
    }

    public performChaptersSearch(data) {
        return this.searchService.performChaptersSearch(data.mfacet)
    }

    @preventStateReload
    public updateURLSearchParams(data) {
        let params = clone(data);
        this.$location.search(params);
    }
}




// WEBPACK FOOTER //
// ./src/main/webapp/components/search/chaptersAndReviews/chaptersAndReviews.service.ts